import { cn } from '@/lib/utils'

interface LogoMarkProps {
  className?: string;
}

export function LogoMark({ className }: LogoMarkProps) {
  return (
    <svg
      className={cn('text-primary-500', className)}
      viewBox="0 0 108 112"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M95.4932 80.3627C98.057 79.3373 100.968 80.5842 101.993 83.1479C103.018 85.7116 101.771 88.6224 99.207 89.6479L57.707 106.248L57.7002 106.25C55.3246 107.197 52.6764 107.196 50.3008 106.25L50.293 106.248L8.79297 89.6479C6.22937 88.6223 4.9825 85.7116 6.00781 83.1479C7.0335 80.5842 9.94401 79.3372 12.5078 80.3627L54 96.9594L95.4932 80.3627ZM95.4932 55.4077C98.0569 54.3823 100.968 55.6292 101.993 58.1928C103.018 60.7566 101.771 63.6672 99.207 64.6928L57.707 81.2924L57.7002 81.2954C55.3246 82.2414 52.6765 82.2413 50.3008 81.2954L50.293 81.2924L8.79297 64.6928C6.2293 63.6671 4.98235 60.7566 6.00781 58.1928C7.0335 55.6291 9.94401 54.3821 12.5078 55.4077L54 72.0043L95.4932 55.4077ZM50.3008 5.75044C52.6765 4.80443 55.3245 4.80433 57.7002 5.75044L57.707 5.75337L97.6875 21.7456H97.6885C99.5534 22.4828 101.155 23.7641 102.282 25.4223C103.41 27.0806 104.013 29.0401 104.013 31.0454C104.013 33.0507 103.41 35.0101 102.282 36.6684C101.155 38.3267 99.5534 39.608 97.6885 40.3452L97.6875 40.3442L57.707 56.3374L57.7002 56.3403C55.3245 57.2864 52.6765 57.2862 50.3008 56.3403L50.2939 56.3374L10.3125 40.3442V40.3452C8.4475 39.608 6.84652 38.3266 5.71875 36.6684C4.59113 35.0101 3.98832 33.0508 3.98828 31.0454C3.98828 29.0399 4.59112 27.0807 5.71875 25.4223C6.77601 23.8677 8.24914 22.6443 9.96582 21.8901L10.3125 21.7456L50.2939 5.75337L50.3008 5.75044ZM14.0078 31.0376C14.0016 31.0401 13.9946 31.0429 13.9883 31.0454C13.9945 31.0478 14.0016 31.0507 14.0078 31.0532L54 47.0502L93.9932 31.0532L94.0127 31.0454C94.0065 31.0429 93.9994 31.04 93.9932 31.0376L54 15.0405L14.0078 31.0376Z" />
    </svg>
  );
}

interface LogoProps {
  className?: string
  showText?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

export function Logo({ className, showText = true, size = 'md' }: LogoProps) {
  const textSizes = {
    xs: 'text-base',
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
  }

  const iconSizes = {
    xs: 'w-4 h-4',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <LogoMark className={iconSizes[size]} />
      {showText && (
        <span className={cn('font-bold text-gray-900', textSizes[size])}>
          Overlay<span className="text-primary-500">QA</span>
        </span>
      )}
    </div>
  )
}
